

























import _ from 'lodash'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { EditorEntry } from '@/store/editor/types'
import { Action, Getter } from 'vuex-class'
import { RootState } from '@/store/types'
import { Maybe } from '@/types/general'
import Entry from '@/data/entry-model'
import { ENTRY_DELETE } from '@/store/editor/constants'

@Component({ name: 'delete-modal' })
export default class DeleteModal extends Vue {
    loading: boolean = false

    @Prop({ type: Object, required: true })
    entry!: EditorEntry

    /**
     * Delete the current entry
     */
    @Action(ENTRY_DELETE)
    del!: () => Promise<boolean>

    @Getter
    getEntry!: (entryId: string) => Promise<Entry>

    get entryTitle(): string {
        return this.entry.fields.title.value || '???'
    }

    get sideEffects(): string {
        if (!this.entry.model!.isVault()) {
            return ''
        }

        const toBeDeleted = this.entry.model!.descendants.map(desc => desc.title)
        return `The following entries contained within this vault will also be deleted:
                <strong>${toBeDeleted.join('</strong>, <strong>')}</strong>.`
    }

    async deleteEntry(): Promise<void> {
        this.loading = true
        try {
            await this.del()
            this.$success({ text: 'Entry deleted' })
        } catch (err) {
            this.$error({ text: `Failed to delete entry: ${err}` })
        } finally {
            this.loading = false
        }
    }
}
